module.exports = __webpack_public_path__ + "media/preview/conference@3x-40536854.png";